module.exports = __webpack_public_path__ + "img/fallback_client.a0497cc3.png";